import { Outlet } from 'react-router-dom'

import { Root, Main } from './styles'
import Nav from './Nav'

const Layout = () => {
  return (
    <Root>
      <Nav />
      <Main>
        <Outlet />
      </Main>
    </Root>
  )
}

export default Layout
